// --------------------------------------
// GCLID site-wide capture + storage
// --------------------------------------
(function () {
    console.log("[GCLID] gclid-storage.js loaded");

    const GCLID_KEY = "gclid";

    function storeGclid(value) {
        if (!value) return;

        console.log("[GCLID] Storing gclid:", value);

        // localStorage (persistent)
        try {
            localStorage.setItem(GCLID_KEY, value);
        } catch (e) {
            console.warn("[GCLID] Could not write gclid to localStorage", e);
        }

        // sessionStorage (tab/session)
        try {
            sessionStorage.setItem(GCLID_KEY, value);
        } catch (e) {
            console.warn("[GCLID] Could not write gclid to sessionStorage", e);
        }

        // cookie (optional; readable by other scripts/server)
        try {
            const maxAge = 60 * 60 * 24 * 90; // 90 days
            document.cookie =
                GCLID_KEY +
                "=" +
                encodeURIComponent(value) + 
                "; path=/; max-age=" +
                maxAge +
                "; SameSite=Lax";
        } catch (e) {
            console.warn("[GCLID] Could not write gclid cookie", e);
        }
    }

    function getGclidFromUrl(url) {
        try {
            const u = new URL(url || window.location.href);
            return u.searchParams.get("gclid");
        } catch (e) {
            return null;
        }
    }

    function captureAndStoreGclid() {
        console.log("[GCLID] captureAndStoreGclid() started");

        // 1) Capture from current URL
        const fromUrl = getGclidFromUrl(window.location.href);
        if (fromUrl) {
            console.log("[GCLID] Found gclid in URL:", fromUrl);
            storeGclid(fromUrl);
            return fromUrl;
        }

        // 2) Fallback: capture from referrer URL (if present)
        if (document.referrer) {
            const fromReferrer = getGclidFromUrl(document.referrer);
            if (fromReferrer) {
                console.log("[GCLID] Found gclid in referrer:", fromReferrer);
                storeGclid(fromReferrer);
                return fromReferrer;
            }
        }

        console.log("[GCLID] No gclid found");
        return null;
    }

    // Run ASAP (also works if script is loaded in <head>)
    const result = captureAndStoreGclid();
    console.log("[GCLID] capture result:", result);

    // Optional: expose manual trigger
    window.captureAndStoreGclid = captureAndStoreGclid;
})();